"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _baseColors = _interopRequireDefault(require("./baseColors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var breadCrumbs = {
  selected: _baseColors["default"].black,
  unselected: _baseColors["default"].atomic,
  separator: _baseColors["default"].atomic
};
var _default = breadCrumbs;
exports["default"] = _default;